import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  blitzes: null,
  statusesCount: {},
  totalPages: 0,
  totalItems: 10
}

const getters = {
  getBlitzes: state => state.blitzes,
  getBlitzesCount: state => state.statusesCount,
  getTotalPages: state => state.totalPages,
  getTotalItems: state => state.totalItems
}

const actions = {
  async fetchBlitzSubmits ({ commit }, getParams) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.blitz.submits(getParams))
      commit('SET_BLITZ_SUBMITS', data)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Something went wrong while get Blitz Submit!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchBlitzCounter ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.blitz.counterBlitz())
      commit(types.SET_COUNTER_BLITZ, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing counter wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async hideOrShowEnvelop ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.hideOrShowEnvelop.updateHideOrShowEnvelop(), payload)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Show or wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addBlitzCompany ({ commit }, newCompany) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.blitz.createBlitz(), newCompany)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Added new company to blitz list!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to create new company!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateBlitzSubmitStatus ({ commit }, { actionString, blitzId }) {
    const reqMethodConfig = {
      approve: 'post',
      delete: 'delete'
    }
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios[reqMethodConfig[actionString]](api.blitz.updateStatus(actionString, blitzId))
      commit('CREATE_SUCCESS_MESSAGE', `Blitz Submit has been successfully ${actionString}d!`)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Something went wrong!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async blitzRemindSubmit ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.blitz.remind(), payload)
      commit('CREATE_SUCCESS_MESSAGE', `Blitz Submit has been successfully posted!`)
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0008') {
        commit('CREATE_ERROR_MESSAGE', 'This blitz has not been submitted yet')
      } else {
        commit('CREATE_ERROR_MESSAGE', 'Something went wrong!')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_BLITZ_SUBMITS] (state, { blitzes, totalPages, totalItems }) {
    state.blitzes = blitzes
    state.totalPages = totalPages
    state.totalItems = totalItems
  },
  [types.SET_COUNTER_BLITZ] (state, { statusesCount }) {
    state.statusesCount = {...statusesCount}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/blitz.js